<app-shipment-system-simplenav></app-shipment-system-simplenav>
<div class="container-fluid pt-3 pb-5">

    <ngb-alert [dismissible]="false" [type]="'info'" *ngIf="hasNewVersion">
        Der er en ny version af KONTROL. Tryk for at <a href="javascript:window.location.reload();">opdatere</a>
    </ngb-alert>

    <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="debugMode">DEMO MODE</ngb-alert>
    <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="hasErrors">{{errorMessage}}</ngb-alert>
    <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="hasValidationErrors">{{validationErrorMessage}}</ngb-alert>
    <ngb-alert [type]="'info'" *ngIf="banner">{{banner}}</ngb-alert>
    <ngb-alert [dismissible]="false" *ngIf="alert" [type]="alertType">
        {{alert}}
    </ngb-alert>

    <form (submit)="processInput()" #form="ngForm" class="d-flex flex-column align-items-center" style="gap: 0.25rem">

        <input [(ngModel)]="search.nota_number" name="notanr" autofocus type="text" class="form-control"
               placeholder="Scan eller indtast"
               style="max-width: 230px"
               (blur)="onBlur($event)" #yourInput>
        <div class="status">
            <span class="status-item">Scanner status:
                <span *ngIf="!activeShipment && dbMode && !rekvNrMode"><strong>Scan DB. nummer</strong></span>
                <span *ngIf="!activeShipment && !dbMode && !rekvNrMode"><strong>Scan notanummer</strong></span>
                <span *ngIf="!activeShipment && rekvNrMode"><strong>Scan rekv. nr.</strong></span>
                <span *ngIf="activeShipment"><strong>Scan vare</strong></span>
            </span>
            <span class="status-item" *ngIf="!dbMode">Bruger: <strong>{{userKey}}</strong></span>
            <span class="status-item" *ngIf="!dbMode" >Bruger Afd.: <strong>{{userBranch}}</strong></span>
            <span class="status-item d-flex flex-row align-content-center align-items-center" *ngIf="showDebug">
                <span class="text-nowrap">Søg Afd.:</span>
               <select class="form-control form-select"
                       name="shipment-route-id"
                       (change)="branchChanged()"
                       [(ngModel)]="branch"
                       [disabled]="loading">
                        <option [value]="null">-</option>
                        <ng-template ngFor let-branch [ngForOf]="branches">
                            <option [value]="branch.key">{{ branch.name }}
                            </option>
                        </ng-template>
                    </select>
            </span>


            <span class="status-item" *ngIf="!dbMode"><a (click)="showDebug = !showDebug"
                                         href="javascript:">{{showDebug ? 'Normal' : 'Avanceret'}} </a></span>
            <span class="status-item">
                                        <a href="javascript:0" (click)="resetAll()" class="btn btn-sm btn-danger">Nulstil</a>
            </span>

            <span class="status-item" *ngIf="!dbMode">
                <button type="button" (click)="createShipment()" class="btn btn-sm btn-success" [disabled]="loading">Opret forsendelse</button>
            </span>


            <span class="status-item" *ngIf="showDebug && activeShipment">
                <button type="button" (click)="createEvent('packing_completed', true)" class="btn btn-sm btn-success" [disabled]="loading">Marker scannet som pakket</button>
            </span>
            <span class="status-item" *ngIf="showDebug && activeShipment">
            <label class="form-label">
            <input type="checkbox" class="switch" [(ngModel)]="addAdditionalShipment" name="addAdditionalShipment"
                   value="addAdditionalShipment"> Tilføj yderligere forsendelse
            </label>
            </span>

        </div>
        <button class="hidden">Søg</button>
    </form>

    <div *ngIf="product_line">
        <table class="table">
            <thead>
            <tr>
                <th>Billede</th>
                <th>Lokation</th>
                <th></th>
                <th>Varenummer</th>
                <th>Varenavn</th>
                <th class="text-end">Dimension</th>
            </tr>
            </thead>
            <tbody>
            <tr app-shipment-product-line
                [showStockLocation]="true"
                [hideWeight]="false"
                [showProductImage]="true"
                [showNumberPicked]="false"
                [hideStock]="true"
                [hideEvents]="true"
                [hideNotes]="true"
                [hideAmount]="true"
                [hidePo]="true"
                [inlineEdit]="false"
                [product_line]="product_line">

            </tr>
            </tbody>
        </table>
    </div>

    <div *ngIf="activeShipment">
        <div class="row mb-3 mt-3 sticky-top pb-2" style="background: white;border-bottom: 1px solid grey">
            <div class="col-2 d-flex flex-column pt-3 pb-3" style="gap: 0.25rem">
                <ng-container *ngFor="let confirmationOption of confirmationOptions">
                    <button
                            *ngIf="confirmationOption.must_confirm"
                            (click)="confirmationOption.has_confirmed = true" class="btn btn-lg"
                            [ngClass]="{'btn-success': confirmationOption.has_confirmed, 'btn-danger': !confirmationOption.has_confirmed}"
                            [disabled]="confirmationOption.has_confirmed">
                        <i class="fas fa-check-circle" *ngIf="confirmationOption.has_confirmed"></i>
                        <i class="fas fa-ban" *ngIf="!confirmationOption.has_confirmed"></i>
                        {{ confirmationOption.warning }}
                    </button>

                    <ngb-alert *ngIf="confirmationOption.must_confirm === false" [dismissible]="false"
                               [type]="'danger'">
                        {{ confirmationOption.warning }}
                    </ngb-alert>
                </ng-container>

                <span class="h3">
                <i class="fas fa-ban text-danger" *ngIf="!shipmentComplete"></i>
                <i class="fas fa-check-square text-success" *ngIf="shipmentComplete"></i>
                </span>
                <div class="h5">
                <span *ngIf="activeShipment.order_reference" class="badge  text-bg-secondary"
                      style="vertical-align: 2px;">web</span> {{ activeShipment.order_reference }}
                </div>
                <div class="h5">
                    <span *ngIf="activeShipment.nota_number" class="badge  text-bg-secondary"
                          style="vertical-align: 2px;">nota</span> {{ activeShipment.nota_number }}
                </div>
                <div class="h5" *ngIf="rekvNrMode">
                    <span *ngIf="activeShipment.nota_number" class="badge  text-bg-secondary"
                          style="vertical-align: 2px;">rekv nr.</span> {{ activeShipment.rekv_number }}
                </div>

                <span class="h5 badge  text-bg-warning"
                      *ngIf="activeShipment.branch !== this.userBranch"
                >Afdeling: {{ activeShipment.branch }}</span>

                <h5>
                <app-shipment-status-widget [status]="activeShipment.shipment_status"
                                            [label]="activeShipment.shipment_status_formatted"
                                            [asBadge]="true"></app-shipment-status-widget>
                </h5>

                <div class="card  mb-3">
                    <div class="card-header">Carrier / Indstillinger</div>
                    <div class="card-body d-flex flex-column gap-1">
                        <img [src]="environment.assetBase +'/assets/img/' + activeShipment.carrier_logo"
                             class="img-fluid"
                             style="max-width: 100px;">
                        <ng-container *ngIf="activeShipmentPackagings">
                            <div class="d-flex align-items-start gap-2 flex-wrap">
                                <ng-container *ngFor="let service of activeShipmentPackagings">
                                    <button
                                            *ngIf="service?.selectable === true"
                                            type="button"
                                            class="btn btn-sm"
                                            [ngClass]="{'btn-outline-success':!service.selected, 'btn-success':service.selected}"
                                            (click)="selectPackaging(service)">{{ service.packageType }}
                                    </button>
                                </ng-container>
                            </div>
                            <ng-container *ngFor="let service of activeShipmentPackagings">
                                <span *ngIf="service.selected">{{ service.description }}  {{service.price ? (service.price | currency:'DKK':'symbol':'1.2-2') : '-'}}</span>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
                <div class="card  mb-3" *ngIf="activeShipment.carrier_code === '907' && activeShipment.is_internal_shipment">
                    <div class="card-header">Følgeseddel</div>
                    <div class="card-body d-flex flex-column gap-1">

                        <ng-container>
                            <button class="btn btn-lg btn-success flex-grow-0"
                                    [disabled]="loading || hasValidationErrors || productLineQueue.length <= 0"
                                    (click)="createEvent('packed_remote', false)">
                                Ordre til følgeseddel
                            </button>
                            <ng-container
                                    *ngIf="ShipmentsService.getBit(activeShipment.delivery_progress, shipmentsService.deliveryBitMasks.bestiltFjernlager)">

                                <span class="text-body-emphasis">Historik:</span>
                                <ng-container *ngFor="let shipmentEvent of activeShipment.shipment_events">
                                    <span *ngIf="shipmentEvent.shipment_status === 'packed_remote'">
                                        {{ shipmentEvent.date.format('DD-MM-YYYY HH:mm') }}: Ordre til følgeseddel <!-- number in sequence -->
                                    </span>
                                </ng-container>
                            </ng-container>
                        </ng-container>

                    </div>
                </div>

                <div class="card  mb-3" *ngIf="activeShipment.is_internal_shipment === false || activeShipment.carrier_code !== '907'">
                    <div class="card-header">Print</div>
                    <div class="card-body d-flex flex-column gap-1">
                        <ng-container *ngIf="mode === null">

                            <ng-container
                                    *ngIf="activeShipment.carrier_code === '999' && activeShipment.status_ordering < 30">
                                <!-- && !boxenMode -->
                                <div *ngIf="!ShipmentsService.getBit(activeShipment.delivery_progress, shipmentsService.deliveryBitMasks.pakket)">
                                    <h5>Pluk til afhentning</h5>

                                    <span>Intern placering:</span>
                                    <div *ngIf="placements && placements.length > 0"
                                         class="d-flex gap-1 flex-wrap mb-3">
                                        <button class="btn btn-secondary"
                                                [ngClass]="{'btn-success' : activePlacements.includes(placement)}"
                                                *ngFor="let placement of placements"
                                                [disabled]="loading"
                                                (click)="togglePlacement(placement)">{{ placement }}
                                        </button>
                                    </div>


                                    <div class="mb-3">
                                        <span>Instruks til kunde:</span>
                                        <div *ngIf="presetComments && presetComments.length > 0"
                                             class="d-flex gap-1 flex-wrap mb-3">
                                            <button class="btn btn-secondary"
                                                    [ngClass]="{'btn-success' : activePresetComments.includes(presetComment)}"
                                                    *ngFor="let presetComment of presetComments"
                                                    [disabled]="loading"
                                                    (click)="toggleComment(presetComment)">{{ presetComment }}
                                            </button>
                                        </div>

                                        <input
                                            (click)="setStopBlur($event)"
                                            (blur)="setStartBlur($event)"
                                            type="text" class="form-control" placeholder="Kommentar" [(ngModel)]="eventComment">
                                    <span class="form-text text-muted">Ekstra tekst til SMS</span>
                                    </div>
                                    <button class="btn btn-lg btn-success flex-grow-0"
                                            [disabled]="loading || hasValidationErrors || productLineQueue.length <= 0"
                                            (click)="createEvent('packing_completed', false)">
                                        Klar til afhentning
                                    </button>

                                </div>

                                <div *ngIf="!ShipmentsService.getBit(activeShipment.delivery_progress, shipmentsService.deliveryBitMasks.afhentet)">
                                    <h5>Registrer afhentning</h5>
                                    <button class="btn btn-lg btn-success flex-grow-0"
                                            [disabled]="loading || hasValidationErrors"
                                            (click)="createEvent('handed_out', false)">
                                        Afhentet
                                    </button>
                                </div>

                                <ng-container *ngIf="boxenMode">
                                    <button class="btn btn-lg btn-success flex-grow-0"
                                            [disabled]="loading || hasValidationErrors || productLineQueue.length <= 0"
                                            (click)="createPackage()"><i class="fas fa-door-open"></i>
                                        Åbn Boxen
                                    </button>
                                </ng-container>
                            </ng-container>

<!--   && activeShipment.carrier_code !== '907' -->
                            <ng-container *ngIf="activeShipment.carrier_code !== '999'">
                                <button *ngIf="isShipmondo && packagesQueue.length === 0" class="btn btn-lg btn-success flex-grow-0"
                                        [disabled]="loading || hasValidationErrors || productLineQueue.length <= 0"
                                        (click)="createPackage()"><i class="fas fa-door-open"></i>
                                    <ng-container *ngIf="!boxenMode"> Opret label <small>med valgte</small></ng-container>
                                </button>
                                <ng-container *ngIf="isShipmondo && showNumberLables">
                                    <button class="btn btn-sm  flex-grow-0 align-self-center" (click)="numberLables = 1" [ngClass]="{'btn-success': numberLables ===1}"><i class="fas fa-box"></i> 1</button>
                                    <button class="btn btn-sm  flex-grow-0 align-self-center" (click)="numberLables = 2" [ngClass]="{'btn-success': numberLables ===2}"><i class="fas fa-box"></i> 2</button>
                                    <button class="btn btn-sm  flex-grow-0 align-self-center" (click)="numberLables = 3" [ngClass]="{'btn-success': numberLables ===3}"><i class="fas fa-box"></i> 3</button>
                                </ng-container>

                                <img *ngIf="imageBase64 && packagesQueue.length ===0"
                                     [src]="imageBase64 ? ('data:image/png;base64,' +imageBase64) : ''"/>

                                <button *ngIf="isShipmondo && (showDebug || packagesQueue.length > 0)" class="btn btn-lg btn-success flex-grow-0"
                                        [disabled]="loading || hasValidationErrors || productLineQueue.length <= 0"
                                        (click)="createPackage(true)"><i class="fas fa-door-open"></i>
                                    Tilføj til print kø</button>

                                <div *ngIf="packagesQueue.length > 0" class="d-flex flex-column gap-2">

                                <button  (click)="printAllLabels()" class="btn btn-sm btn-success">Print alle labels</button>

                                <span>Label kø:</span>
                                <div *ngFor="let shipmentPackage of packagesQueue" class="mb-2 border-1 border border-rounded p-2 d-flex flex-column gap-2">
                                    <span [innerHTML]="shipmentPackage.getDescription() | newlineToBr"></span>
                                    <span *ngIf="shipmentPackage.weight">
                                {{ shipmentPackage.weight | number:'1.0-2' }} kg
                                </span>
                                    <span>
                                    {{ shipmentPackage.package_type }}
                                    </span>
                                </div>
                                </div>
                            </ng-container>
                        </ng-container>

                    </div>
                </div>

                <ul class="list-group mb-3">
                    <li class="list-group-item d-flex flex-column align-items-start" *ngIf="activeShipment.placement">
                        <span class="badge  text-bg-secondary">placering</span>
                        <span
                                class="h5">{{ activeShipment.placement ? activeShipment.placement : '-' }}</span>
                    </li>
                </ul>

                <div class="card  mb-3">
                    <div class="card-header">Status</div>
                    <div class="card-body d-flex flex-column gap-1">

                        <p>Antal varer i pakkekø: {{ productLineQueue.length }}</p>
                        <ul>
                            <li><strong>Antal labels:</strong> {{ numberLables }}</li>
                            <li *ngIf="kolliData" [ngClass]="{'text-danger': kolliData.sumWeight > 19}"
                            ><strong>Samlet vægt:</strong>
                                <ng-container *ngIf="kolliData">
                                    <span [ngClass]="{'text-decoration-line-through':kolliData.sumWeightOverrideActive,'text-warning': kolliData.sumWeightOverrideActive}">
                                        {{ kolliData.sumWeight | number:'1.2-2':'da' }} kg
                                    </span>

                                    <div *ngFor="let i of [].constructor(numberLables); let index = index">
                                        <label>Pakke {{ index + 1 }}
                                            <span class="text-success" *ngIf="kolliData.sumWeightOverride[index]">{{ kolliData.sumWeightOverride[index] | number:'1.2-2':'da' }} kg</span>
                                        </label>
                                        <input type="text" class="form-control" name="weight"
                                               *ngIf="editPackage"
                                               [ngModel]="kolliData.sumWeight"
                                               (ngModelChange)="updateOverride($event, index)"

                                        >
                                    </div>
                                    <button (click)="overridePackageSettings()" class="btn btn-sm btn-link">{{editPackage?'Gem vægt':'Overstyr vægt'}}</button>
                                </ng-container>
                            </li>
                            <li><strong>Samlet volumen:</strong>
                                <ng-container *ngIf="kolliData"> {{ kolliData.sumVolume | number:'1.2-2':'da' }}m3
                                </ng-container>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="card  mb-3">
                    <div class="card-header">Adresser</div>
                    <div class="card-body d-flex flex-column gap-1">
                        <app-shipment-address [address]="activeShipment?.shipment_address"
                                             [label]="'Modtager Adresse'"></app-shipment-address>

                        <app-shipment-address [address]="activeShipment?.sender_address"
                                              [label]="'Afsender Adresse'"></app-shipment-address>

                        <app-shipment-address
                                *ngIf="activeShipment?.is_droppoint"
                                [address]="activeShipment?.droppoint_address"
                                             [label]="'Droppoint'"></app-shipment-address>

                        <a [routerLink]="'/shipment/' + activeShipment.id" [queryParams]="{'return_to':'control'}"
                           class="text-info" style="cursor: pointer;"><i class="fas fa-link"></i> Se detailer</a>
                    </div>
                </div>

                <div class="card  mb-3">
                    <div class="card-header">Services</div>
                    <div class="card-body d-flex flex-column gap-1">
                        <p *ngIf="activeShipment.shipment_services.length === 0" class="text-muted  text-center">No
                            services</p>
                        <ul *ngIf="activeShipment.shipment_services.length > 0" class="table  table-sm">
                            <ng-template ngFor let-shipmentService [ngForOf]="activeShipment.shipment_services">
                                <li>
                                    <span>{{ shipmentService.service_name }}</span>
                                </li>
                            </ng-template>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-9">

                <div class="card text-center mb-3">
                    <div class="card-header">
                        <ul class="nav nav-tabs card-header-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" aria-current="true" href="javascript:void(0)">Afventer</a>
                            </li>
                        </ul>
                    </div>
                    <div class="card-body p-0">
                        <table class="table table-sm m-0 table-borderless rounded-2">
                            <thead>
                            <tr>
                                <th></th>
                                <th>#</th>
                                <th>Note</th>
                                <th>TUN</th>
                                <th>Tekst</th>
                                <th class="text-end">Antal</th>
                                <th class="text-end">Vægt</th>
                                <th class="text-end">Antal Scannet</th>
                                <th class="text-end">Status</th>
                            </tr>
                            </thead>

                            <tbody>
                            <ng-template ngFor let-product_line
                                         [ngForOf]="shipmentProductLines | metaFilterAlt:'picking-incomplete'"
                                         let-i="index">
                                <tr app-shipment-product-line
                                    (modalOpened)="modalOpened($event)"
                                    (refresh)="pick($event,product_line)"
                                    [shipment]="getShipmentForProductLine(product_line)"
                                    [product_line]="product_line" [i]="i"
                                    [showNumberPicked]="true"
                                    [hideEvents]="true"
                                    [hidePo]="true"
                                    [hideStock]="true"
                                    [hideNotes]="false"
                                    [showProductImage]="true"
                                    [ngClass]="{'last-edited' : product_line === lastEditedProductLine }"></tr>
                            </ng-template>
                            </tbody>
                        </table>
                    </div>
                </div>


                <div class="card text-center">
                    <div class="card-header">
                        <ul class="nav nav-tabs card-header-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" aria-current="true" href="javascript:void(0)">Er pakket</a>
                            </li>
                        </ul>
                    </div>
                    <div class="card-body p-0">


                        <table class="table  table-sm m-0 table-borderless rounded-2">
                            <thead>
                            <tr>
                                <th></th>
                                <th>#</th>
                                <th>Note</th>
                                <th>TUN</th>
                                <th>Tekst</th>
                                <th class="text-end">Antal</th>
                                <th class="text-end">Vægt</th>
                                <th class="text-end">Antal Scannet</th>
                                <th class="text-end">Status</th>
                            </tr>
                            </thead>

                            <tbody>
                            <ng-template ngFor let-product_line [ngForOf]="shipmentProductLines | metaFilterAlt:'picking-complete'" let-i="index">
                                <tr app-shipment-product-line
                                    (modalOpened)="modalOpened($event)"
                                    (refresh)="pick($event,product_line)"
                                    [shipment]="getShipmentForProductLine(product_line)"
                                    [product_line]="product_line" [i]="i"
                                    [showNumberPicked]="true"
                                    [hideEvents]="true"
                                    [hidePo]="true"
                                    [hideStock]="true"
                                    [hideNotes]="false"
                                    [showProductImage]="true"
                                    [ngClass]="{'last-edited' : product_line === lastEditedProductLine }"></tr>
                            </ng-template>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div *ngIf="showDebug">
                    <p>Queue:</p>
                    <ul class="list-group">
                        <ng-template ngFor let-product_line [ngForOf]="productLineQueue" let-i="index">
                            <li class="list-group-item d-flex justify-content-between align-items-center">{{ product_line.product_text_1 }}
                                {{product_line.amount_scanned}} /
                                {{product_line.amount_picked}} / {{product_line.amount}}

                                <span class="badge text-bg-primary rounded-pill">{{ product_line.product_number }}</span>
                            </li>
                        </ng-template>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <app-spinner *ngIf="loading"></app-spinner>

    <div *ngIf="showDebug" class="fixed-bottom p-1" style="height: 40px;overflow: scroll;background: white;border-top: 1px solid #a7a7a7">

        {{additionalShipments|json}}
        <div class="row">
            <div class="col-12">
<pre class="small"><span *ngFor="let logItem of operationsLog">{{logItem}}
</span></pre>
            </div>
        </div>
    </div>
</div>
